<div>
	<div class="row">
		<div class="col-sm-6">
			<div class="c-form-group">
				<div class="c-form-group__label">
					<label for="backgroundColor">Background Color</label>
				</div>
				<div class="input-group" [(colorPicker)]="sharedService.customTheme.config.background" [cpAlphaChannel]="'disabled'" [cpOutputFormat]="'hex'">
					<input id="backgroundColor" cclFormInput type="text" [(ngModel)]="sharedService.customTheme.config.background" class="c-c-form-group__input form-control">

					<div class="input-group-append">
						<span class="c-color-picker input-group-text" [ngStyle]="{'background-color': sharedService.customTheme.config.background}">&nbsp;</span>
					</div>
				</div>
				<div class="c-form-group__hint">&nbsp;</div>
			</div>
		</div>
		<div class="col-sm-6">
			<div class="c-form-group">
				<div class="c-form-group__label">
					<label for="accentColor">Accent Color</label>
				</div>
				<div class="input-group" [(colorPicker)]="sharedService.customTheme.config.accent" [cpAlphaChannel]="'disabled'" [cpOutputFormat]="'hex'"
				 [cpPosition]="'left'">
					<input id="accentColor" cclFormInput type="text" [(ngModel)]="sharedService.customTheme.config.accent" class="c-c-form-group__input form-control">

					<div class="input-group-append">
						<span class="c-color-picker input-group-text" [ngStyle]="{'background-color': sharedService.customTheme.config.accent}">&nbsp;</span>
					</div>
				</div>
				<div class="c-form-group__hint">&nbsp;</div>
			</div>
		</div>
		<div class="col-sm-6">
			<div class="c-form-group">
				<div class="c-form-group__label">
					<label for="type1Color">Type 1 Color</label>
				</div>
				<div class="input-group" [(colorPicker)]="sharedService.customTheme.config.type_1" [cpAlphaChannel]="'disabled'" [cpOutputFormat]="'hex'"
				 [cpPosition]="'left'">
					<input id="type1Color" cclFormInput type="text" [(ngModel)]="sharedService.customTheme.config.type_1" class="c-c-form-group__input form-control">

					<div class="input-group-append">
						<span class="c-color-picker input-group-text" [ngStyle]="{'background-color': sharedService.customTheme.config.type_1}">&nbsp;</span>
					</div>
				</div>
				<div class="c-form-group__hint">&nbsp;</div>
			</div>
		</div>
		<div class="col-sm-6">
			<div class="c-form-group">
				<div class="c-form-group__label">
					<label for="type2Color">Type 2 Color</label>
				</div>
				<div class="input-group" [(colorPicker)]="sharedService.customTheme.config.type_2" [cpAlphaChannel]="'disabled'" [cpOutputFormat]="'hex'"
				 [cpPosition]="'left'">
					<input id="type2Color" cclFormInput type="text" [(ngModel)]="sharedService.customTheme.config.type_2" class="c-c-form-group__input form-control">

					<div class="input-group-append">
						<span class="c-color-picker input-group-text" [ngStyle]="{'background-color': sharedService.customTheme.config.type_2}">&nbsp;</span>
					</div>
				</div>
				<div class="c-form-group__hint">&nbsp;</div>
			</div>
		</div>

	</div>
</div>